var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function ColumnLabel(props) {
    const { children, active } = props, rest = __rest(props, ["children", "active"]);
    return (<Box width="100%" alignItems="center" gap="md" {...rest}>
      {active ? (<Falcon icon="grip-lines" $color="primary.400"/>) : (<Falcon icon="grip-lines" $color="primary.100"/>)}
      {children}
    </Box>);
}
